module.exports = __webpack_public_path__ + "img/WF_18_sm.485493dc.jpg";